import process from "process";
import devConstants from "./constants.development";
import testConstants from "./constants.test";
import prdConstants from "./constants.production";
import genStorageKeyByAppType from "../utils/app/genStorageKeyByAppType";

const envConstantsMap = {
  production: prdConstants,
  test: testConstants,
  development: devConstants,
};

// @ts-ignore
const envConstants = envConstantsMap[process.env.DEPLOY_ENV] || devConstants;
const DEFAULT_INFORMATIZATION_SERVICE = "/school-informatization-server";

const resolveInformatizationService = () => {
  if (process.env.DEV_INFORMATIZATION_SERVICE === "zgy") {
    return "/school-informatization-server-zgy";
  }

  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return DEFAULT_INFORMATIZATION_SERVICE;
  }

  return window.localStorage.getItem("DEV_INFORMATIZATION_SERVICE") === "zgy"
    ? "/school-informatization-server-zgy"
    : DEFAULT_INFORMATIZATION_SERVICE;
};

export const {
  SERVER_URL,
  BASE_SALES_SERVER_URL,
  BASE_USER_BEHAVIOR_SERVER_URL,
  DEPLOY_DIR,
  APP_URL,
  ACTIVITY_MARKET_ORIGIN,
  H5_STATIC_SERVER_URL,
  WX_APPID,
  WX_MP_APP_ID,
  SHOW_MAI_DIAN_LOG,
  ALLOW_MOBILE_LOGIN_PAGE,
  JW_APP_URL,
  JW_KUAIPK_APP_URL,
  JW_KUAIJW_APP_URL,
  JW_KUAIJK_APP_URL,
  JW_KUAIXK_APP_URL,
  JW_KUAIFB_APP_URL,
  JW_KUAICJ_APP_URL,
  AI_CHATBOT_BASE_URL,
  AI_CUSTOMER_BASE_URL,
  KUAI_JW_CONSULTATION_URL,
} = envConstants;

// 后端服务前缀
export const BASE_SYSTEM_USER = "/base-system-user";
export const SUPPORT_SERVICE = "/school-informatization-server";
export const BASE_SCHOOL_COURSE = "/base-school-course";
export const BASE_SCHOOL_TEACHER = "/base-school-teacher";
export const BASE_SCHOOL = "/base-school";
export const SCHEDULING_ENGINE = "/schedule/engine/scheduleproject";
export const BASE_PARSE = "/base-parse";
export const BASE_SALES = "/base-sales";
export const BASE_USER_BEHAVIOR = "/base-user-behavior";
export const BASE_NCEE_CLASS_SCHEDULING = "/base-nceeclassscheduling"; // 新版课表
export const BASE_ARRANGE_EXAM_ROOM = "/base-arrangexamroom"; // 排监考
export const BASE_SCHEDULING = "/base-newscheduling"; // 新版排课
export const BASE_INFORMATIZATION = resolveInformatizationService(); // 信息化系统
export const BASE_NEW_SCHEDULING = BASE_INFORMATIZATION; // 新版排课
export const BASE_CHATBOT = "/base-chatbot";
export const KUAIJZ_MP_APP_ID = "wxb31a32b804116817"; // 倍思家长微信小程序appid

// 前端localStorage相关Key
export const USER_TOKEN = "user_token"; // token：跨应用共享的唯一 localStorage key
export const USER_ID = genStorageKeyByAppType("user_id"); // 用户id
export const WECOM_CORP_ID = genStorageKeyByAppType("wecom_corp_id"); // 企微用户企业id
export const SCHOOL_INFO = genStorageKeyByAppType("school_info"); // 学校信息
export const SCHEMA_SHARED = genStorageKeyByAppType("schema_shared"); // 是否已经分享
export const SCHEDULE_HAS_TOUR = genStorageKeyByAppType("schedule_has_tour"); // 是否已经引导
export const SCHEDULE_TIP_ODD = genStorageKeyByAppType("schedule_tip_odd"); // 是否已经提示单双周操作
export const SCHEDULE_TIP_COMBINE = genStorageKeyByAppType("schedule_tip_combine"); // 是否已经提示合班操作
export const SCHEDULE_TIP_STRATIFIED = genStorageKeyByAppType("schedule_tip_stratified"); // 是否已经提示分层操作
export const SCHEDULE_TIP_SORT = genStorageKeyByAppType("schedule_tip_sort"); // 是否已经提示排序操作
export const SCHEDULE_TIP_BATCH_INPUT = genStorageKeyByAppType("schedule_tip_batch_input"); // 是否已经提示批量操作
export const SCHEDULE_IMPORT_SHEETS_DATA = genStorageKeyByAppType("schedule_import_sheets_data"); // 导入文件后的表格数据
export const KUAIPK_TIPS = genStorageKeyByAppType("kuaipk_tips"); // 提示集合
export const SELECT_SUBJECT_CURRENT_TASK = genStorageKeyByAppType("select_subject_current_task"); // 提示集合
export const DIVIDE_CLASS_CURRENT_TASK = genStorageKeyByAppType("divide_class_current_task"); // 提示集合
export const CLASS_SCHEDULE_CURRENT_TASK = genStorageKeyByAppType("class_schedule_current_task"); // 提示集合
export const DIVIDE_INVIGILATE_CURRENT_TASK = genStorageKeyByAppType(
  "divide_invigilate_current_task",
); // 排监考当前taskId
export const SCHEDULE_CURRENT_TASK_ID = genStorageKeyByAppType("schedule_current_task_id"); // 当前方案id
export const NEW_SCHEDULE_CURRENT_TASK_ID = genStorageKeyByAppType("new_schedule_current_task_id"); // 走班排课当前任务ID
export const TRAINING_COURSE_CURRENT_SCHEDULE_ID = genStorageKeyByAppType(
  "training_course_current_schedule_id",
); // 培训班排课当前taskId
export const PREVIEW_EXPORT_SELECT_TEMPLATE_ID = genStorageKeyByAppType(
  "preview_export_select_template_id",
); // 排课预览导出选中模板ID
export const PREVIEW_EXPORT_PARAMS = genStorageKeyByAppType("preview_export_params"); // 排课预览导出参数缓存
export const COURSE_HOUR_STAT_WEEK_CONFIG = genStorageKeyByAppType("course_hour_stat_week_config"); // 课时统计周次配置
export const VIP_EXPIRED_MODAL = genStorageKeyByAppType("VIP_EXPIRED_MODAL"); // 课时统计周次配置
export const COURSE_MANAGE_PARSED_COURSE_SCHEDULE = genStorageKeyByAppType(
  "course_manage_parsed_course_schedule",
); // 课务管理 - 已解析的课表
export const COURSE_MANAGE_PARSED_XGK_COURSE_SCHEDULE = genStorageKeyByAppType(
  "course_manage_parsed_xgk_course_schedule",
); // 课务管理 - 已解析的课表
export const TEACHER_HOME_RECOMMENDATION_FLAG = genStorageKeyByAppType(
  "teacher_home_recommendation_pending",
); // 注册后首页应用推荐引导
export const NEW_PROFILE_ENTRY_FLAG = genStorageKeyByAppType("new_profile_entry_allowed"); // 新版个人中心入口标记
export const PARSED_COURSE_SCHEDULE = genStorageKeyByAppType("parsed_course_schedule");
export const PARSED_XGK_COURSE_SCHEDULE = genStorageKeyByAppType("parsed_xgk_course_schedule");

export const VISITOR_FROM = genStorageKeyByAppType("visitor_from"); // 用户来源
export const VISITOR_REF = genStorageKeyByAppType("visitor_ref"); // 用户页面来源
export const KUAIPK_RECEIVE_DATA = genStorageKeyByAppType("kuaipk_receive_data");
// 待清除
export const KUAIPK_CURRENT_TEAM = "KUAIPK_CURRENT_TEAM"; // 排课当前团队信息

// 当前发布课表方案id
export const PUBLISH_TIMETABLE_CURRENT_ID = genStorageKeyByAppType("publish_timetable_current_id");

// 当前fj发布课表方案id
export const FJ_PUBLISH_TIMETABLE_CURRENT_ID = genStorageKeyByAppType(
  "fj_publish_timetable_current_id",
);

// 邀请引导相关
export const INVITE_TOUR_ALL_FINISHED = genStorageKeyByAppType("invite_tour_all_finished"); // 是否已结束全部引导
